import PropTypes from 'prop-types';
import { Box, List, ListItem, Typography } from '@mui/material';
import theme from 'theme';

const PolicyBulletList = ({ items }) => (
  <List sx={{ listStyleType: 'disc', paddingLeft: theme.spacing(4), paddingTop: theme.spacing(1) }}>
    {items.map((item, index) => (
      <ListItem
        key={index}
        sx={{
          display: 'list-item',
          paddingLeft: 0,
          paddingTop: 0,
          paddingBottom: theme.spacing(0.5),
        }}
      >
        <Typography variant="body1" component="span">
          {item.label && <Box component="strong" fontWeight={600}>{`${item.label} `}</Box>}
          {item.text}
        </Typography>
      </ListItem>
    ))}
  </List>
);

PolicyBulletList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default PolicyBulletList;
